import { createAction } from "typesafe-actions";
import { Language } from "./types";

export const setLanguage = createAction("ASSESSMENT/LANGUAGE_SET")<Language>();
